import React from 'react'
import { LibraryPostVideoCard as LibraryPostVideoCardComponent } from '@superhi/design'

import { buildPath } from 'src/routing'
import { API } from 'src/api'
import { SUPERLIBRARY_URL } from 'src/config'

type ComponentProps = Omit<
  React.ComponentProps<typeof LibraryPostVideoCardComponent>,
  'link' | 'type' | 'image' | 'difficultyLevel'
>

type Props = API.LibraryPostVideoCardComponent &
  ComponentProps & {
    __typename: 'LibraryPostVideo'
    slug: string
    noDescription?: boolean
    imageLazy?: boolean
  }

const LibraryPostVideoCard: React.FC<React.PropsWithChildren<Props>> = ({
  slug,
  image,
  noDescription,
  description,
  imageLazy = false,
  ...props
}) => {
  const imageProps = React.useMemo(
    () => ({
      src: image.url,
      srcSet: '',
      sizes: '',
      lazy: imageLazy,
      blurHash: image.blurhash,
    }),
    [image, imageLazy],
  )

  const href = `${SUPERLIBRARY_URL}/posts/${slug}`

  return (
    <LibraryPostVideoCardComponent
      {...props}
      link={{ href, isExternal: true }}
      image={imageProps}
      headingLevel="3"
      description={noDescription ? undefined : description}
    />
  )
}

export { default as FRAGMENT } from './fragments'
export default LibraryPostVideoCard
